// extracted by mini-css-extract-plugin
export default {"bodyDiagram":"BodyDiagram_bodyDiagram__EUbkc"};